export class AssistiveObjectsHandler implements AssistiveObjectsHolder{

    private assistiveObjects: AssistiveObject[] = [];

    constructor(){
    }

    addAssistiveObject(listener: AssistiveObject){
        if(listener){
            this.assistiveObjects.push(listener);
            console.log("added assistive obj");
        }
    }

    removeAssistiveObject(listener: AssistiveObject){
        if(listener){
            for(var index = 0; index  < this.assistiveObjects.length; index++){
                if(this.assistiveObjects[index] == listener){
                    this.assistiveObjects.splice(index, 1)
                    console.log("removed assistive obj");
                }
            }
        }
    }

    updateAssistiveObjects(canvasCtx : CanvasRenderingContext2D, playStatus : number){
        if(this.assistiveObjects.length > 0){
            for(var listener of this.assistiveObjects){
                listener.draw(canvasCtx, playStatus);
            }
        }
    }
}

export interface AssistiveObjectsHolder{
    addAssistiveObject(listener: AssistiveObject): void;
    removeAssistiveObject(listener: AssistiveObject): void;
}

export interface AssistiveObject{
    draw(canvasCtx : CanvasRenderingContext2D, playStatus : number): void;
}